// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3Sr8B","colMaxWidth":"Table_colMaxWidth__26I5m"};